import { SxProps, Theme } from '@mui/material';
import Box from '@mui/material/Box';
import { startCase } from 'lodash-es';

import { OverflowAwareText } from '~components/Order/ordersDispatchStyledComponents';
import { Job } from '~hooks/useJob/models';
import { Load } from '~hooks/useLoad/models';
import { Ticket } from '~hooks/useTickets/models';
import { getTicketMaterial, getTicketQuantityAndUom } from '~utils/tickets/ticket-utils';
import { numberToIntegerOrDecimal } from '~utils/utilFunctions';

interface QuantityAndMaterialColumnProps {
  job?: Job;
  load: Load;
  sx?: SxProps<Theme>;
  ticket?: Ticket;
}

export default function QuantityAndMaterialColumn({
  job,
  load,
  sx,
  ticket,
}: QuantityAndMaterialColumnProps) {
  const quantityAndUom = getTicketQuantityAndUom(ticket, load, job);
  const material = getTicketMaterial(ticket, load, job)?.name;

  return (
    <Box sx={sx}>
      <OverflowAwareText sx={{ fontWeight: 600 }}>
        {quantityAndUom
          ? `${numberToIntegerOrDecimal(quantityAndUom.quantity)} ${startCase(quantityAndUom.uom)}`
          : '-'}
      </OverflowAwareText>

      <OverflowAwareText sx={(theme) => ({ color: theme.brandV2.colors.treadGray2 })}>
        {material ?? '-'}
      </OverflowAwareText>
    </Box>
  );
}
